"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridColumn = void 0;
const cellRenderers_1 = require("./cellRenderers");
const GridColumn = () => null;
exports.GridColumn = GridColumn;
exports.GridColumn.defaultProps = {
    headerCell: cellRenderers_1.headerCellRenderer,
    cell: cellRenderers_1.textCellRenderer,
    hidden: false
};
//# sourceMappingURL=GridColumn.js.map